/* TP-G Farm — Learn page enhancements (progressive enhancement).
   1) Reveal-on-scroll: content is fully visible without JavaScript. The hidden
      state lives ONLY under `.tpg-learn.is-reveal-ready`, added after init.
   2) Journal carousel: the track is a native horizontal scroller (works with
      swipe/keyboard/no-JS). JS only adds arrow controls and disabled states.
   Loaded with `defer`. */
(function () {
  'use strict';

  function initReveal(root) {
    if (root.dataset.tpgRevealReady === 'true') return;
    root.dataset.tpgRevealReady = 'true';

    var els = root.querySelectorAll('.tpg-l-reveal');
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!els.length || reduced || !('IntersectionObserver' in window)) return;

    root.classList.add('is-reveal-ready');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCarousel(root) {
    if (root.dataset.tpgCarouselReady === 'true') return;
    var car = root.querySelector('[data-tpg-carousel]');
    if (!car) return;
    var track = car.querySelector('.tpg-l-carousel__track');
    if (!track) return;
    root.dataset.tpgCarouselReady = 'true';

    var scope = car.closest('.tpg-l-section') || root;
    var prev = scope.querySelector('[data-tpg-prev]');
    var next = scope.querySelector('[data-tpg-next]');

    root.classList.add('is-carousel-ready');

    function step() {
      var item = track.querySelector('.tpg-l-carousel__item');
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 22;
      return item ? item.getBoundingClientRect().width + gap : Math.round(track.clientWidth * 0.8);
    }
    function update() {
      // Tolerance absorbs the track's small resting offset (scroll-snap + left padding),
      // so prev is disabled at the true start and next at the true end.
      var tol = 6;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= tol;
      if (next) next.disabled = track.scrollLeft >= max - tol;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    initReveal(root);
    initCarousel(root);
  }

  function boot() {
    var roots = document.querySelectorAll('.tpg-learn');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-initialize when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var root = target.classList && target.classList.contains('tpg-learn')
      ? target
      : target.querySelector('.tpg-learn');
    if (root) {
      root.dataset.tpgRevealReady = '';
      root.dataset.tpgCarouselReady = '';
      root.classList.remove('is-reveal-ready');
      root.classList.remove('is-carousel-ready');
      init(root);
    }
  });
})();
